import React, { useCallback, useRef } from 'react'
import { useMemo } from 'react'
import { customersColumns } from './columns/_columns'
import { Customer } from '../core/_models'
import GenericTable, {
  GenericTableHandle
} from '../../../../components/GenericTable'
import { useAuth } from '../../../../context/Auth'
import {
  PaginatedResponse,
  PaginationMeta
} from '../../../../interfaces/PaginatedResponse'
import { list } from '../../../../lib/fetch/customers'

interface UsersTableProps {
  filters: any
}

const UsersTable = ({ filters }: UsersTableProps) => {
  const [{ token }] = useAuth()
  const ref = useRef<GenericTableHandle>(null)
  const refetch = useCallback(() => {
    ref.current?.refetch()
  }, [ref])
  const columns = useMemo(() => customersColumns(refetch), [refetch])
  const fetch = useCallback(
    async (
      paginationMeta: PaginationMeta
    ): Promise<PaginatedResponse<Customer> | string> => {
      let result
      try {
        result = await list({
          token,
          page: paginationMeta.currentPage,
          limit: paginationMeta.itemsPerPage,
          ...filters
        })
      } catch (error) {
        let message = 'Error'
        if (error instanceof Error) {
          message = error.message
        }
        result = message
      }
      return result
    },
    [filters, token]
  )

  return <GenericTable columns={columns} onFetch={fetch} ref={ref} />
}

export { UsersTable }
